export default __webpack_public_path__ + "static/media/logo_infinite.82838644.svg";